import { Stack, Box, Typography, IconButton } from "@mui/material";
import { TrashIcon } from "@/components/common/icons";
import { MoxieImage } from "@/components/common/images/moxieImage";
import { GREY } from "@/config/mui/colorPalette";
import useMoxieMediaQuery from "@/hooks/misc/useMoxieMediaQuery";
import useOnlineStorePackagesStore from "@/store/views/onlineStore/onlineStorePackagesStore";
import { formattedPrice } from "@/utils";
import { MedspaPackage } from "@/views/online-store/onlineStoreView";
import PackageCardStoreButton from "../packages/oldPackageCard/oldPackageCardStoreButton";

export default function PackageCartItem({
  packageItem,
  medspaId,
  customizationEnabled,
  customizationPrimaryColor,
}: {
  packageItem: MedspaPackage;
  medspaId: string;
  customizationEnabled: boolean;
  customizationPrimaryColor: string;
}) {
  const store = useOnlineStorePackagesStore(medspaId);

  const {
    changePackageQuantity,
    getPackageQuantity,
    setPackageQuantity,
    removePackage,
  } = store.getState();

  const packageQuantity = getPackageQuantity(packageItem.id);

  const onAmountChange = (change: 1 | -1) => {
    changePackageQuantity(packageItem.id, change);
  };

  const isMobile = useMoxieMediaQuery("ipad-ver", "down");

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box>
        <MoxieImage
          imageUrl={
            packageItem.additionalInfo?.thumbnail || "/assets/images/gift.png"
          }
          width={64}
          height={64}
          style={{ borderRadius: "8px", minWidth: "64px" }}
        />
      </Box>
      <Stack
        sx={{
          flexGrow: 1,
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitleDefault">
            {packageItem.packageName}
          </Typography>
          <IconButton onClick={() => removePackage(packageItem.id)}>
            <TrashIcon color={GREY[50]} />
          </IconButton>
        </Stack>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <PackageCardStoreButton
            packageQuantity={packageQuantity}
            onAmountChange={onAmountChange}
            onInputChange={(value) => {
              setPackageQuantity(packageItem.id, +value);
            }}
            unitPrice={+packageItem.packagePrice}
            isMobile={isMobile}
            customizationEnabled={customizationEnabled}
            customizationPrimaryColor={customizationPrimaryColor}
            type="checkout"
          />
          <Typography variant="labelSmall">
            {formattedPrice(+packageItem.packagePrice * packageQuantity)}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
